<template>
  <div style="min-height: 100vh; position: relative">
    <v-container fluid>
      <v-layout wrap>
        <v-flex v-if="['studio7', 'ticket2'].includes(selectedBot.theme)" xs4 class="mb-2">
          <div>
            <multiselect
              @input="getSummary"
              :allow-empty="false"
              :show-labels="false"
              :searchable="false"
              label="name"
              v-model="selectedCom7page"
              :options="$store.state.com7pages"
            >
            </multiselect>
            <!-- :options="[{ name: 'All', pageid: null }, ...$store.state.com7pages]" -->
          </div>
        </v-flex>
        <v-flex xs12></v-flex>
        <v-flex
          xs12
          sm6
          v-if="
            !['105911105134578', '101931352240400', ...$store.state.pageListSingGaling].includes(
              selectedBot.pageid
            )
          "
        >
          <v-btn
            depressed
            :outline="filter != 'all'"
            :color="filter == 'all' ? 'primary' : 'grey'"
            @click="
              filter = 'all'
              getSummary()
            "
            class="ma-0 mr-1 mb-1"
            >{{ $t('All') }}</v-btn
          >
          <v-btn
            depressed
            :outline="filter != 'facebook'"
            :color="filter == 'facebook' ? 'primary' : 'grey'"
            @click="
              filter = 'facebook'
              getSummary()
            "
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-facebook-square mr-1" />
            {{ $t('Facebook') }}
          </v-btn>
          <v-btn
            depressed
            :outline="filter != 'line'"
            :color="filter == 'line' ? 'primary' : 'grey'"
            @click="
              filter = 'line'
              getSummary()
            "
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-line mr-1" />
            {{ $t('Line') }}
          </v-btn>
          <template v-if="selectedBot && ['gpf', 'trueid', 'mtc'].includes(selectedBot.type)">
            <v-btn
              depressed
              :outline="filter != 'webchat'"
              :color="filter == 'webchat' ? 'primary' : 'grey'"
              @click="
                filter = 'webchat'
                getSummary()
              "
              class="ma-0 mr-1 mb-1"
            >
              <em class="fas fa-globe mr-1" />
              Web Chat
            </v-btn>
          </template>

          <template v-if="selectedBot && selectedBot.type === 'gpf'">
            <v-btn
              depressed
              :outline="filter != 'app'"
              :color="filter == 'app' ? 'primary' : 'grey'"
              @click="
                filter = 'app'
                getSummary()
              "
              class="ma-0 mr-1 mb-1"
            >
              <em class="fas fa-mobile-alt mr-1" />
              App Chat
            </v-btn>
          </template>
        </v-flex>
        <v-flex v-else xs12 sm6> </v-flex>
        <v-flex xs12 sm6 class="text-sm-right">
          <template v-if="loading">
            <v-btn :loading="true" color="grey" outline class="ma-0 mb-1"></v-btn>
          </template>
          <template v-else>
            <v-btn
              v-if="$store.getters.getPackage != 'premium'"
              outline
              v-tooltip.top="'Unlock to PREMIUM plan'"
              color="grey"
              class="ma-0 mb-1"
            >
              <em class="fas fa-file-export mr-1" />
              <span class="mr-2">{{ $t('export') }}</span>
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
            <v-btn
              v-else-if="$store.getters.getPackage == 'premium'"
              @click="exportDashboard"
              color="grey"
              outline
              class="ma-0 mb-1"
              :disabled="isError"
            >
              <em class="fas fa-file-export mr-1" />
              {{ $t('export') }}
            </v-btn>
          </template>
        </v-flex>
      </v-layout>

      <date-filter
        v-model="selectedDate"
        @onSelected="getSummary"
        :default-filter="'today'"
      ></date-filter>
      <h3 class="title mt-5 mb-2">{{ $t('Total number of users since installing chatbot') }}</h3>
      <!-- <p class="title">{{$t('Total number of users since installing chatbot')}}</p> -->
      <v-layout wrap>
        <v-flex xs12 sm12 md6 lg5 class="pa-1">
          <v-card style="border-radius: 5px">
            <v-card-title>
              <span>{{ $t('total user') }}</span>
            </v-card-title>
            <div class="body">
              <div class style="position: relative">
                <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
                <template v-if="totaluserSeries">
                  <div style="max-width: 350px; margin: auto">
                    <apexchart
                      ref="totaluser"
                      type="pie"
                      :options="totaluser"
                      :series="totaluserSeries"
                    ></apexchart>
                  </div>
                </template>
              </div>
            </div>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md6 lg7>
          <v-layout wrap>
            <v-flex xs12 sm6 md6 lg12 class="pa-1">
              <stat-card v-model="summary.totalusers" :loading="loading">{{
                $t('total user')
              }}</stat-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
              <stat-card v-model="totaluserSeries[2]" :loading="loading">
                {{ $t('no gender') }}
                <span
                  style="color: #d4d4d4"
                  v-tooltip.top="
                    $t('Number of non-male and non-female users who talked with chatbot (All time)')
                  "
                >
                  <em class="fas fa-info-circle" />
                </span>
              </stat-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
              <stat-card v-model="totaluserSeries[0]" :loading="loading">
                {{ $t('male') }}
                <span
                  style="color: #d4d4d4"
                  v-tooltip.top="$t('Number of male users who talked with chatbot (All time)')"
                >
                  <em class="fas fa-info-circle" />
                </span>
              </stat-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
              <stat-card v-model="totaluserSeries[1]" :loading="loading">
                {{ $t('Female') }}
                <span
                  style="color: #d4d4d4"
                  v-tooltip.top="$t('Number of female users who talked with chatbot (All time)')"
                >
                  <em class="fas fa-info-circle" />
                </span>
              </stat-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
              <stat-card
                v-model="summary.activeusers"
                :loading="loading"
                :disabled="!selectedBot.status"
              >
                {{ $t('active users') }}
                <span
                  style="color: #d4d4d4"
                  v-tooltip.top="
                    $t('Number of users who talked with chatbot during') +
                    ' ' +
                    dateFormat(selectedDate.start, 'DD/MM/YYYY') +
                    ' - ' +
                    dateFormat(selectedDate.end, 'DD/MM/YYYY')
                  "
                >
                  <em class="fas fa-info-circle" />
                </span>
              </stat-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
              <stat-card
                v-model="summary.newusers"
                :loading="loading"
                :disabled="!selectedBot.status"
              >
                {{ $t('new users') }}
                <span
                  style="color: #d4d4d4"
                  v-tooltip.top="
                    $t('Number of new users who talked with chatbot during') +
                    ' ' +
                    dateFormat(selectedDate.start, 'DD/MM/YYYY') +
                    ' - ' +
                    dateFormat(selectedDate.end, 'DD/MM/YYYY')
                  "
                >
                  <em class="fas fa-info-circle" />
                </span>
              </stat-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
              <stat-card
                v-model="summary.existingusers"
                :loading="loading"
                :disabled="!selectedBot.status"
              >
                {{ $t('existing users') }}
                <span
                  style="color: #d4d4d4"
                  v-tooltip.top="
                    $t('active users') +
                    ' - ' +
                    $t('new users') +
                    ' ' +
                    dateFormat(selectedDate.start, 'DD/MM/YYYY') +
                    ' - ' +
                    dateFormat(selectedDate.end, 'DD/MM/YYYY')
                  "
                >
                  <em class="fas fa-info-circle" />
                </span>
              </stat-card>
            </v-flex>
            <v-flex xs12 v-if="!selectedBot.status">
              <div
                class="caption grey lighten-3 py-1 px-2 ma-1 text-xs-center"
                style="border-radius: 50px"
              >
                {{ $t('Information will not be recorded in analytics if the bot is inactivated') }}
              </div>
            </v-flex>

            <v-divider />
          </v-layout>
        </v-flex>
      </v-layout>

      <!-- <v-divider class="mt-2 mb-2" /> -->
      <v-layout wrap class="hidden-sm-and-up">
        <!--         <v-flex xs12 sm6 md6 lg6 fill-height class="pa-1 pr-1 ">
          <h3 class="title">
            {{ $t('Total number of messages received since installing chatbot') }}
          </h3>
          <stat-card v-model="summary.totalmessages" :loading="loading">
            {{ $t('total messages') }}
            <span
              style="color:#d4d4d4"
              v-tooltip.top="$t('Number of messages that chatbot had replied (All time)')"
            >
              <em class="fas fa-info-circle"/>
            </span>
          </stat-card>
        </v-flex>-->
        <v-flex xs12 sm6 md6 lg6 fill-height class="pa-1 pl-2">
          <h3 class="title">{{ $t('Current number of messages received') }}</h3>
          <stat-card v-model="summary.activemessages" :loading="loading">
            {{ $t('active messages') }}
            <span
              style="color: #d4d4d4"
              v-tooltip.top="
                $t('Number of messages that chatbot had replied during') +
                ' ' +
                dateFormat(selectedDate.start, 'DD/MM/YYYY') +
                ' - ' +
                dateFormat(selectedDate.end, 'DD/MM/YYYY')
              "
            >
              <em class="fas fa-info-circle" />
            </span>
          </stat-card>
        </v-flex>
      </v-layout>

      <v-layout wrap class="hidden-xs-only">
        <!--         <v-flex xs12 sm6 md6 lg6 fill-height class="pa-1 pr-1 ">
          <h3 class="title">
            {{ $t('Total number of messages received since installing chatbot') }}
          </h3>
        </v-flex>-->
        <v-flex xs12 sm12 md12 lg12 fill-height class="pa-1 pl-2">
          <h3 class="title">{{ $t('Current number of messages received') }}</h3>
        </v-flex>
        <!--         <v-flex sm12 fill-height class="pa-1 pr-1 ">
          <stat-card v-model="summary.totalmessages" :loading="loading">
            {{ $t('total messages') }}
            <span
              style="color:#d4d4d4"
              v-tooltip.top="$t('Number of messages that chatbot had replied (All time)')"
            >
              <em class="fas fa-info-circle"/>
            </span>
          </stat-card>
        </v-flex>-->

        <v-flex sm12 fill-height class="pa-1 pr-1">
          <stat-card v-model="summary.activemessages" :loading="loading">
            {{ $t('active messages') }}
            <span
              style="color: #d4d4d4"
              v-tooltip.top="
                $t('Number of messages that chatbot had replied during') +
                ' ' +
                dateFormat(selectedDate.start, 'DD/MM/YYYY') +
                ' - ' +
                dateFormat(selectedDate.end, 'DD/MM/YYYY')
              "
            >
              <em class="fas fa-info-circle" />
            </span>
          </stat-card>
        </v-flex>
      </v-layout>

      <!-- <h3 class="title mt-5 mb-2">{{ $t('Comment') }}</h3> -->
      <v-layout wrap>
        <!--         <v-flex xs12 sm6 md4 lg3 class="pa-1">
          <stat-card v-model="summary.totalreplycomments" :loading="loading">{{
            $t('Total reply comments')
          }}</stat-card>
        </v-flex>-->
        <!--         <v-flex xs12 sm6 md4 lg3 class="pa-1">
          <stat-card v-model="summary.totalreplyinbox" :loading="loading">{{
            $t('Total reply inbox')
          }}</stat-card>
        </v-flex>-->
        <!--         <v-flex xs12 sm6 md4 lg3 class="pa-1">
          <stat-card v-model="summary.totalhidecomment" :loading="loading">{{
            $t('Total hide comments')
          }}</stat-card>
        </v-flex>-->
        <!-- <v-flex xs12 sm6 md4 lg4 class="pa-1">
          <stat-card v-model="summary.activereplycomments" :loading="loading">
            {{ $t('Active reply comments') }}
          </stat-card>
        </v-flex>
        <v-flex xs12 sm6 md4 lg4 class="pa-1">
          <stat-card v-model="summary.activereplyinbox" :loading="loading">
            {{ $t('Active reply inbox') }}
          </stat-card>
        </v-flex>
        <v-flex xs12 sm6 md4 lg4 class="pa-1">
          <stat-card v-model="summary.activehidecomment" :loading="loading">
            {{ $t('Active hide comments') }}
          </stat-card>
        </v-flex> -->
        <v-flex xs12 sm6 md4 lg3 class="pa-1"></v-flex>
      </v-layout>
    </v-container>
    <div class="mt-5 mb-5"></div>
    <template v-if="selectedBot.theme == 'universalutilities'">
      <v-divider></v-divider>
      <uu-broadcast-stat
        :datefrom="selectedDate.start"
        :dateto="selectedDate.end"
      ></uu-broadcast-stat>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import numeral from 'numeral'
import VueApexCharts from 'vue-apexcharts'
import multiselect from 'vue-multiselect'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import DashboardGraphLoading from './DashboardGraphLoading'
import DateFilter from './DateFilter'
import StatCard from './StatCard'
import UuBroadcastStat from './UuBroadcastStat'

export default {
  components: {
    DateFilter,
    StatCard,
    ScaleLoader,
    PulseLoader,
    apexchart: VueApexCharts,
    DashboardGraphLoading,
    UuBroadcastStat,
    multiselect
  },
  data: function () {
    return {
      selectedCom7page: {
        pageid: null,
        name: ''
      },
      isError: false,
      summary: {
        totalmessages: 0,
        activemessages: 0,
        activeusers: 0,
        totalusers: 0,
        newusers: 0
      },
      loading: true,
      filter: 'all',
      totaluserSeries: [0, 0, 0],
      totaluser: {
        chart: {
          type: 'pie'
          // height: 350
        },
        labels: [this.$t('male'), this.$t('female'), this.$t('no gender')],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                // width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        legend: {
          show: true,
          position: 'bottom'
        }
      },
      selectedDate: {
        start: moment().format('YYYY-MM-DD 00:00'),
        end: moment().format('YYYY-MM-DD 23:59')
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  mounted: function () {
    if (['studio7', 'ticket2'].includes(this.selectedBot.theme)) {
      let com7page = this.$store.state.com7pages.find((f) => f.pageid == this.selectedBot.pageid)
      this.selectedCom7page.name = com7page.name
    }
    this.getSummary()
  },
  methods: {
    dateFormat: function (date, format) {
      return moment(date).format(format)
    },
    getSummary: function () {
      let vm = this
      let data = {
        pageid: this.selectedBot.pageid,
        datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'),
        dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'),
        app: this.filter != 'all' ? this.filter : null
      }
      vm.isError = false
      vm.loading = true

      var selectedApi = 'getDashboardSummary'
      if (['studio7', 'ticket2'].includes(this.selectedBot.theme)) {
        selectedApi = 'getcom7pagereport_summary'
        data.pageid = this.selectedCom7page.pageid
          ? this.selectedCom7page.pageid
          : this.selectedBot.pageid
      }
      api[selectedApi](data, function (error, response) {
        if (error) {
          vm.$swal.fire({
            title: vm.$t('Please refresh the page and try again.'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          vm.isError = true
          vm.loading = false
          return
        }
        if (response.data) {
          if (response.data.length > 0) {
            vm.summary.totalmessages = response.data[0].totalmessages
            vm.summary.activemessages = response.data[0].activemessages
            try {
              vm.summary.activeusers =
                parseInt(response.data[0].activeusers) > parseInt(response.data[0].newusers)
                  ? response.data[0].activeusers
                  : response.data[0].newusers
            } catch (error) {
              vm.summary.activeusers = response.data[0].activeusers
            }
            vm.summary.totalusers = response.data[0].totalusers
            vm.summary.newusers = response.data[0].newusers
            vm.summary.existingusers = vm.summary.activeusers - vm.summary.newusers

            vm.summary.totalhidecomment = response.data[0].totalhidecomment
            vm.summary.totalreplycomments = response.data[0].totalreplycomments
            vm.summary.totalreplyinbox = response.data[0].totalreplyinbox
            vm.summary.activehidecomment = response.data[0].activehidecomment
            vm.summary.activereplycomments = response.data[0].activereplycomments
            vm.summary.activereplyinbox = response.data[0].activereplyinbox

            vm.totaluserSeries = [
              parseInt(response.data[0].totalusers_male),
              parseInt(response.data[0].totalusers_female),
              parseInt(response.data[0].totalusers_other)
            ]
          } else {
            vm.summary.totalmessages = 0
            vm.summary.activemessages = 0
            vm.summary.activeusers = 0
            vm.summary.totalusers = 0
            vm.summary.newusers = 0

            vm.totaluserSeries = [0, 0, 0]
          }
        }
        vm.$nextTick(function () {
          vm.loading = false
        })
      })
    },
    exportDashboard: function () {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }

      let json = []
      json.push(['(Since installing chatbot)'])

      json.push([this.$t('total user'), numeral(vm.summary.totalusers).format('0,0')])
      json.push([
        this.$t('no gender'),
        numeral(parseInt(vm.totaluserSeries[2])).format('0,0'),
        numeral((vm.totaluserSeries[2] * 100) / vm.summary.totalusers).format('0.0') + '%'
      ])
      json.push([
        this.$t('male'),
        numeral(parseInt(vm.totaluserSeries[0])).format('0,0'),
        numeral((vm.totaluserSeries[0] * 100) / vm.summary.totalusers).format('0.0') + '%'
      ])
      json.push([
        this.$t('female'),
        numeral(parseInt(vm.totaluserSeries[1])).format('0,0'),
        numeral((vm.totaluserSeries[1] * 100) / vm.summary.totalusers).format('0.0') + '%'
      ])

      json.push([this.$t('active users'), numeral(vm.summary.activeusers).format('0,0')])
      json.push([this.$t('new users'), numeral(vm.summary.newusers).format('0,0')])
      json.push([
        this.$t('existing users'),
        numeral(vm.summary.activeusers - vm.summary.newusers).format('0,0')
      ])
      json.push([])

      json.push([
        `${this.$t('from')} ` +
          moment(vm.selectedDate.start).format('DD/MM/YYYY HH:mm') +
          ` ${this.$t('to')} ` +
          moment(vm.selectedDate.end).format('DD/MM/YYYY HH:mm')
      ])
      json.push(['Total Users by active user'])
      // json.push(['Total Messages', numeral(vm.summary.totalmessages).format('0,0')])
      json.push([this.$t('active messages'), numeral(vm.summary.activemessages).format('0,0')])

      const dataWS = XLSX.utils.aoa_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'zwizdata-dashboard.xlsx')

      // csvContent +=
      //   'From,"' +
      //   moment(vm.selectedDate.start).format('DD/MM/YYYY') +
      //   '",To,"' +
      //   moment(vm.selectedDate.end).format('DD/MM/YYYY') +
      //   '"\r\n'
      // csvContent += '\r\n'
      // csvContent += 'Total Users,"' + numeral(vm.summary.totalusers).format('0,0') + '"\r\n'
      // csvContent +=
      //   'No Gender Users,"' +
      //   numeral(parseInt(vm.totaluserSeries[2])).format('0,0') +
      //   '","' +
      //   numeral((vm.totaluserSeries[2] * 100) / vm.summary.totalusers).format('0.0') +
      //   '%"\r\n'
      // csvContent +=
      //   'Male Users,"' +
      //   numeral(parseInt(vm.totaluserSeries[0])).format('0,0') +
      //   '","' +
      //   numeral((vm.totaluserSeries[0] * 100) / vm.summary.totalusers).format('0.0') +
      //   '%"\r\n'
      // csvContent +=
      //   'Female Users,"' +
      //   numeral(parseInt(vm.totaluserSeries[1])).format('0,0') +
      //   '","' +
      //   numeral((vm.totaluserSeries[1] * 100) / vm.summary.totalusers).format('0.0') +
      //   '%"\r\n'
      // csvContent += + '"\r\n'
      // csvContent += + '"\r\n'
      // csvContent += + '"\r\n'
      // csvContent += + '"\r\n'
      // csvContent += '\r\n'

      // vm.exportCsv(csvContent, 'crm')
    }
  },
  filters: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style lang="scss" scoped>
.totalmessagex {
  border-right: 1px solid #cecece;
  padding-right: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/dashboard/StatSummary.vue